/**
 * Строит партнёрскую ссылку Viator на страницу страны.
 * Формат: https://www.viator.com/{pathSegment}/d{destinationId}-ttd?pid=...&mcid=...&medium=link
 * 
 * @param {Object} params
 * @param {string} params.pathSegment - сегмент пути из схемы country (например, "Montenegro")
 * @param {number} params.destinationId - ID страны в Viator (например, 4475)
 * @param {Object} params.affiliateProvider - данные провайдера из Sanity (с pid, mcid, medium)
 * @returns {string|null} финальная партнёрская ссылка или null если данных недостаточно
 */
export function buildViatorCountryLink({
    pathSegment,
    destinationId,
    affiliateProvider
}) {
    // Проверяем обязательные параметры
    if (!pathSegment || !destinationId) {
        if (process.env.NODE_ENV === 'development') {
            console.warn('⚠️ Viator: отсутствуют pathSegment или destinationId', { pathSegment, destinationId });
        }
        return null;
    }

    // Формируем базовый URL Viator
    // Формат: https://www.viator.com/{pathSegment}/d{destinationId}-ttd
    const baseUrl = `https://www.viator.com/${encodeURIComponent(pathSegment)}/d${destinationId}-ttd`;

    // Если нет провайдера, возвращаем базовый URL
    if (!affiliateProvider) {
        return baseUrl;
    }

    // Создаем URL объект для добавления параметров
    try {
        const url = new URL(baseUrl);

        // Добавляем defaultParams из Sanity (pid, mcid, medium и т.д.)
        if (affiliateProvider.defaultParams && Array.isArray(affiliateProvider.defaultParams)) {
            affiliateProvider.defaultParams.forEach(param => {
                if (param.key && param.value) {
                    url.searchParams.set(param.key, param.value);
                }
            });
        }

        return url.toString();
    } catch (error) {
        if (process.env.NODE_ENV === 'development') {
            console.error('❌ Ошибка при построении ссылки Viator:', error);
        }
        return baseUrl;
    }
}

